import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import { connectToAllMiddlewares, destroyMidConnection } from './common/AllSocketsMiddleware';
import api from './api';

const apiCaller = getApiInstance();

function initEnvironment() {
    return (dispatch, getState) => {
        return apiCaller
            .call(api.initEnvironment())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE_SET_CONFIG',
                        config: {
                            clientInterface: data.clientInterface,
                            groupId: data.groupId,
                            assigneeIds: data.assigneeIds
                        }
                    });

                    let access_token = localStorage.getItem('access_token');
                    if (access_token) access_token = access_token.replace(/"/g, '');

                    /** Middleware Connection **/
                    if (typeof data.middlewaresConfig !== 'undefined') {
                        connectToAllMiddlewares(dispatch, getState, access_token, data.middlewaresConfig);
                    }
                }
                if (data.homes) {
                    dispatch({
                        type: 'FHE__SET_HOMES',
                        homes: data.homes
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                if (data.boxes) {
                    dispatch({
                        type: 'FHE__SET_BOXES',
                        boxes: data.boxes
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                if (data.brands) {
                    dispatch({
                        type: 'FHE__SET_BRANDS',
                        brands: data.brands
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                if (data.prefixFheCenter) {
                    dispatch({
                        type: 'FHE__SET_PREFIX_FHE_CENTER',
                        prefixFheCenter: data.prefixFheCenter
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';

                return data;
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironmentFhe - ', error);
                throw error;
            });
    };
}

function disconnectEnvironment() {
    return dispatch => {
        destroyMidConnection();
        dispatch({
            type: 'RESET_STORE'
        });
    };
}

function getNewProduct(homeId, productType, productIdentifier) {
    return apiCaller
        .call(api.getProductsDetails(homeId, productType, productIdentifier))
        .then(({ data }) => {
            if (data.success) {
                return data;
            }
            return data;
        })
        .catch(error => {
            Logger.log('dataActions: setFheProductsDetails - ', error);
            throw error;
        });
}

export { initEnvironment, disconnectEnvironment, getNewProduct };



// WEBPACK FOOTER //
// ./environments/fhe/actions.js